/**
 * Utility functions for project-related operations
 */

/**
 * Escapes a string for use in CSV content
 * @param content The content to escape
 * @returns The escaped string
 */
export const escapeCSVField = (content: any): string => {
  if (content === null || content === undefined) {
    return '';
  }
  
  const stringContent = String(content);
  
  // If the field contains quotes, commas, or newlines, it needs special handling
  if (stringContent.includes('"') || stringContent.includes(',') || stringContent.includes('\n')) {
    // Replace double quotes with two double quotes (CSV escaping)
    const escapedContent = stringContent.replace(/"/g, '""');
    // Wrap in quotes
    return `"${escapedContent}"`;
  }
  
  return stringContent;
};

/**
 * Format timestamp in YYYY-MM-DD HH:mm:ss format
 * @param timestamp ISO timestamp string
 * @returns Formatted timestamp string
 */
export const formatTimestamp = (timestamp: string | undefined): string => {
  if (!timestamp) {
    return '';
  }
  
  try {
    const date = new Date(timestamp);
    
    // Format as YYYY-MM-DD HH:mm:ss
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  } catch (error) {
    console.error('Error formatting timestamp:', error);
    return timestamp;
  }
};
